export default __webpack_public_path__ + "static/media/compass.41f96e4e.png";